// extracted by mini-css-extract-plugin
export var container = "_fq-0";
export var content = "_fq-3";
export var customerTitle = "_fq-4";
export var empty = "_fq-5";
export var gray = "_fq-6";
export var header = "_fq-7";
export var info = "_fq-8";
export var loading = "_fq-2";
export var loadingCard = "_fq-9";
export var oneLine = "_fq-a";
export var personName = "_fq-e";
export var pillContainer = "_fq-b";
export var selected = "_fq-1";
export var text = "_fq-c";
export var twoLines = "_fq-d";
export var unread = "_fq-f";
export var unreadIndicator = "_fq-g";